module.exports = __webpack_public_path__ + "static/media/jcb.471f1b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jcb.svg
// module id = 285
// module chunks = 0